import { useCallback } from "react";
import { storage } from "@/lib/storage";
import { trackEvent } from "@/lib/analytics";

const API = process.env.REACT_APP_BACKEND_URL;
const DEVICE_KEY = "atlas.deviceId";

/** Anonymous per-device voter id (uuid in localStorage); logged-in users are identified by cookie server-side. */
export function deviceId() {
  let id = storage.get(DEVICE_KEY);
  if (!id) {
    id = (crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^A-Za-z0-9_-]/g, "");
    storage.set(DEVICE_KEY, id);
  }
  return id;
}

export const likeHeaders = () => ({ "X-Device-Id": deviceId() });

/** Returns toggle(reviewId) which POSTs the like and patches the review inside `setData`. */
export function useLikeToggle(setData, code) {
  return useCallback(async (reviewId) => {
    const r = await fetch(`${API}/api/reviews/${reviewId}/like`, { method: "POST", credentials: "include", headers: likeHeaders() });
    if (!r.ok) return;
    const { liked, likes } = await r.json();
    setData((d) => ({ ...d, reviews: d.reviews.map((x) => (x.id === reviewId ? { ...x, likes, liked_by_me: liked } : x)) }));
    trackEvent(liked ? "like_media" : "unlike_media", { country_code: code });
  }, [setData, code]);
}

export const byLikes = (a, b) => (b.likes || 0) - (a.likes || 0) || new Date(b.created_at) - new Date(a.created_at);
